import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { API_FORMAT_PHONE } from '@store/constants/routes';
import { captureException } from '@yoweb/utils/sentry';
export var formatPhone = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var phoneNumber, countryCode, query, response, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            phoneNumber = _ref.phoneNumber, countryCode = _ref.countryCode;

            if (phoneNumber) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", {
              isValid: false,
              phoneNumber: phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : ''
            });

          case 3:
            _context.prev = 3;
            query = new URLSearchParams(_objectSpread({
              phoneNumber: phoneNumber
            }, countryCode && {
              countryCode: countryCode
            }));
            _context.next = 7;
            return fetch("".concat(API_FORMAT_PHONE, "?").concat(query.toString()));

          case 7:
            response = _context.sent;

            if (response.ok) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", {
              isValid: false,
              phoneNumber: phoneNumber
            });

          case 10:
            _context.next = 12;
            return response.json();

          case 12:
            data = _context.sent;
            return _context.abrupt("return", {
              isValid: data.isValid,
              phoneNumber: data.phoneNumber
            });

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](3);
            captureException(_context.t0);
            return _context.abrupt("return", {
              isValid: false,
              phoneNumber: phoneNumber
            });

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 16]]);
  }));

  return function formatPhone(_x) {
    return _ref2.apply(this, arguments);
  };
}();